import React from 'react';

const News = () => {
  return (
    <div id="news" className="container">
      <div className="content">
        <h2>MEDIA COVERAGE</h2>
        <div className="news news-item-1">
          <div className="col left">
            <img src="./img/newspaper.jpg" alt=""/>
          </div>
          <div className="col right">
            <h3>A Change of Clothes</h3>
            <h4>Gladys Henriquez makes statements of social justice through her shirt designs.</h4>
            <blockquote>"Gladys Henriquez is taking on the injustices she sees in the world one T-shirt at a time. Early this year, she launched the Anti-Bullying Clothing Co. with her mother, Daly Perez. Although she herself has never been bullied, she recognizes the issue as a serious one. “I’m just a very compassionate person ... and just the fact that kids die and kill themselves.... People get traumatized forever. You hear adults telling their stories about when they were bullied and it’s heartbreaking,” she said. Part of the proceeds from sales will go to organizations"</blockquote>
            <a href="http://www.westsidespirit.com/local-news/20170725/a-change-of-clothes/3" target="_blank">Read the full article here >></a>
          </div>
        </div>
        <hr />
        <div className="news news-item-2">
          <h3>"Real Life Wonder Women"</h3>
          <h4>The AntiBully Clothing Co Was Featured on Fox: Good Day Street Talk</h4>
          <div className="video-wrapper">
            <div className="video-container">
              <iframe width="560" height="315" src="https://www.youtube.com/embed/4OYqU8VyWdQ" frameborder="0" allowfullscreen></iframe>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default News;



// WEBPACK FOOTER //
// ./src/components/home/News.js